import React, { useEffect,useState } from 'react';
import '../App.css';
import ListIcons from '../Components/Lib/ListIcons';
import * as R from 'ramda'
import * as api from "../api/apiFunc";

//import {fetchDict,fetchColu} from './Actions/actions'

const ShowAppToolbar = (props) => {
    const { config } = props
    const [curBlock, SetCurBlock] = useState([])
    const [iconsApp, SetIconsApp] = useState([])
    const [inputVal, SetInputVal] = useState('')
      
    useEffect(() => {
        if (api.isEmpty(config.configApp)) return
        //console.log('config.configApp',config.configApp);
        SetCurBlock(R.find(R.propEq("block", config.name))(config.configApp)) 
        SetIconsApp(config.iconsApp) 
    }, [config]);

  const ComputedAccess = () => {
       if (api.isEmpty(config.configApp)) return []
       let curBlock = R.find(R.propEq("block", config.name))(config.configApp)
       if (!(!api.isEmpty(curBlock) && !api.isEmpty(curBlock.children[0]))) return [] 
      //  if (!api.isNotEmptyArr(curBlock) || !api.isNotEmptyArr(curBlock.children[0])) return [] 
        let access = {}  
        curBlock.children[0].icons.map((icon) => {
              const iconapp = R.find(R.propEq('ui_app_icon_id', icon.id))(config.iconsApp)
              switch (iconapp.ui_app_icon_mnem) {
                  case "refresh": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "save": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "add": access = {...access, [iconapp.ui_app_icon_mnem]: 1  }
                  break
                  //case "copy": access = {...access, [iconapp.ui_app_icon_mnem]: -1 }
                  //break
                  //case "edit": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  //break
                  case "filter": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  case "filteroff": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  break
                  //case "print": access = {...access, [iconapp.ui_app_icon_mnem]: 1 }
                  //break
                  case "delete": access = {...access,  [iconapp.ui_app_icon_mnem]: 1 }
                  break
              }
        })
        return access  
    }

    const ShowFilter = () => {
      const { pick,mainfilter} = props
      if (api.isEmpty(mainfilter) || !api.isNotEmptyArr(pick))
        return null
      let curPeriod = null
      let curUser = null
      let curVidp = null

      const curUsers = R.find(R.propEq('name', 'Users'))(pick).rows 
      const User = R.find(R.propEq('pkid', mainfilter.user_id))(curUsers)
      
      const curVidps = R.find(R.propEq('name', 'Vidp'))(pick).rows 
      const Vidp = R.find(R.propEq('pkid', mainfilter.category_id))(curVidps)

      if (!api.isEmpty(User)) curUser = `ФИО = ${User.title}`
      if (!api.isEmpty(Vidp)) curVidp = `Тип = ${Vidp.title}`
      if (typeof mainfilter.period === "string") {
        const curDate = new Date(mainfilter.period + '-01')
        curPeriod = `Период = ${curDate.toLocaleDateString("ru-RU", { month: 'long' })} ${curDate.toLocaleDateString("ru-RU", { year: 'numeric' })}`
      }
      
      const cstyle = {margin: '2px 10px',padding: '2px', width: '30%', border: '1px solid rgba(0,0,0,0.5)',borderRadius:'5px',color : '#000', backgroundColor :'#faf5c5'}
      const iconapp = R.find(R.propEq('name', 'search'))(config.iconsApp)
      return (<div className="filter-cell">
        {curVidp && <div style={cstyle}>{curVidp}</div>}
        {curPeriod && <div style={cstyle}>{curPeriod}</div>}
        {curUser && <div style={cstyle}>{curUser}</div>}
      </div>)
  }

    const FindB = () => {
        //if (!curBlock || !api.isNotEmptyArr(curBlock.children)) return null
    
        const iconapp = R.find(R.propEq('name', 'search'))(config.iconsApp)
        return (<div className="search-cell">
          <form>
            <input
              type="text"
              style={{ border: 'none'}}
              value={inputVal}
              onChange={(e) => {SetInputVal(e.target.value) }/* props.handleFilterUpdated*/}
            />
            {curBlock.children && curBlock.children[1] &&
              <ListIcons classnam="App-toolsbar-search-style" icons={curBlock.children[1].icons} iconsapp={iconsApp} access={{ "search": 1 }} handleOnClick={props.handleSeek} dopargs={{arg1:inputVal}} />}   
          </form>
        </div>)
    }
    const access = ComputedAccess() 

    const IconMenuClick = (id) => {
        const iconapp = R.find(R.propEq('ui_app_icon_id', id))(iconsApp)
        console.log('id ==== ',id);
        switch (iconapp.ui_app_icon_mnem) {
            case "refresh": alert('refresh') ; break;
            case "save": props.onSaveData(); /*props.onSaveData();*/ break;
            case "add": props.onInsertRow(); break;
            case "copy": alert('copy'); break;
            case "edit": alert('edit'); break;
            case "filter": props.onColumnFilter(); break;
            case "filteroff": props.onColumnFilter(); break;
            case "print": alert('print'); break;
            case "delete": props.onDeleteRow(); break;
        }
     }
     if (api.isEmpty(config.configApp)) return
     let cur_Block = R.find(R.propEq("block", config.name))(config.configApp)
     if (!api.isNotEmptyArr(cur_Block.children) || !api.isNotEmptyArr(iconsApp)) return null 
 
    return (
        <div className="App-toolsbar" /*style = {this.props.config.style}*/>
          <div>
           <div className='row-toolbar'>
            <div className='col-toolbar-1  Tool-bar-butt'>
                {cur_Block.children && cur_Block.children[0] &&
                  <ListIcons classnam="App-toolsbar-icons-style" filtered={props.filtered} icons={cur_Block.children[0].icons} iconsapp={iconsApp} access={access} handleOnClick={IconMenuClick} />}   
              </div>
              <div className='col-toolbar-2'>
                 {ShowFilter()}
              </div>
              <div className='col-toolbar-3'>
                  {FindB()}
              </div>

            </div>
         </div>
        </div>

    );
}
  
export default ShowAppToolbar
